document.addEventListener('DOMContentLoaded', function () {
  var drawer = document.getElementById('mobile-menu');
  var images = window.blacksmithMobileShopCategoryImages || {};
  if (!drawer || !Object.keys(images).length) return;

  function syncImages() {
    var cards = drawer.querySelectorAll('.blacksmith-mobile-menu__shop-card');

    cards.forEach(function (card) {
      var pathname = '';

      try {
        pathname = new URL(card.href, window.location.origin).pathname.replace(/\/$/, '');
      } catch (error) {
        pathname = card.getAttribute('href') || '';
      }

      if (images[pathname]) {
        card.style.backgroundImage = 'url("' + images[pathname] + '")';
      }
    });
  }

  syncImages();

  var observer = new MutationObserver(syncImages);
  observer.observe(drawer, { childList: true, subtree: true });
});
